import { render } from "./AddReducedPositionToWarehouseModal.vue?vue&type=template&id=62542f0e&scoped=true"
import script from "./AddReducedPositionToWarehouseModal.vue?vue&type=script&lang=js"
export * from "./AddReducedPositionToWarehouseModal.vue?vue&type=script&lang=js"

import "./AddReducedPositionToWarehouseModal.vue?vue&type=style&index=0&id=62542f0e&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62542f0e"]])

export default __exports__